

<app-navbar></app-navbar>
<div class="betweenWrapper">
    <router-outlet></router-outlet>
    </div>
<app-footer></app-footer>